'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentProps, useId } from 'react';
import ActionWorldCardBadgeList from '@/components/ActionWorldCardBadgeList';
import ActionWorldCardRankingBadge from '@/components/ActionWorldCardRankingBadge';
import ViverseWorldCardInfo from '@/components/ViverseWorldCardInfo';
import ViverseWorldCardMedia from '@/components/ViverseWorldCardMedia';
import { useWorldCardContext } from '@/context/ViverseWorldCardContext';
import { useCardInteraction } from '@/hooks/useCardInteraction';
import { useCardPrefetchRef } from '@/hooks/useCardPrefetchRef';
import { useDwellPlayback } from '@/hooks/useDwellPlayback';
import { cn } from '@/lib/utils';
export default function ViverseWorldCardDefault(t0) {
  const $ = _c(45);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    info,
    vodId,
    cardType,
    disableAutoPreview,
    ranking,
    rankingIndex,
    cardOnly,
    isMission,
    isNew,
    isUpdated,
    isExclusive,
    isSelected,
    isHot,
    isTop
  } = useWorldCardContext();
  const fallbackId = useId();
  const uniqueId = info.id || fallbackId;
  const {
    isHovered,
    isHoverSupported,
    onPointerEnter,
    onPointerLeave,
    onContextMenu,
    onTouchStart,
    onTouchEnd,
    onTouchCancel
  } = useCardInteraction(uniqueId);
  const t1 = disableAutoPreview ? undefined : vodId;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      vodId: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    ref: dwellRef,
    isPlaying: isDwellPlaying
  } = useDwellPlayback(t2);
  let t3;
  if ($[5] !== vodId) {
    t3 = () => {
      if (!vodId) {
        return;
      }
      fetch(`/api/hover-video/${vodId}`).catch(console.debug);
    };
    $[5] = vodId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const cardRef = useCardPrefetchRef(t3);
  const t4 = cardType === "experiences" && "p-2 shadow-[0_0_0_1px_rgba(255,255,255,0.1)] md:p-2 lg:hover:shadow-[0_0_0_5px_rgba(89,102,119,0.15),0_12px_32px_rgba(0,0,0,0.45)]";
  const t5 = ranking || isMission || isNew || isExclusive || isSelected || isHot || isTop;
  let t6;
  if ($[7] !== className || $[8] !== t4 || $[9] !== t5) {
    t6 = cn("group @container relative select-none", "flex flex-col gap-1 rounded-3xl transition-all duration-300", t4, className, {
      relative: t5
    });
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== ranking || $[12] !== rankingIndex) {
    t7 = ranking && <ActionWorldCardRankingBadge index={rankingIndex} />;
    $[11] = ranking;
    $[12] = rankingIndex;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== cardType || $[15] !== isExclusive || $[16] !== isHot || $[17] !== isMission || $[18] !== isNew || $[19] !== isSelected || $[20] !== isTop || $[21] !== isUpdated || $[22] !== ranking) {
    t8 = <ActionWorldCardBadgeList isMission={isMission} isNew={isNew} isUpdated={isUpdated} isExclusive={isExclusive} isSelected={isSelected} isHot={isHot} isTop={isTop} ranking={ranking} cardType={cardType} />;
    $[14] = cardType;
    $[15] = isExclusive;
    $[16] = isHot;
    $[17] = isMission;
    $[18] = isNew;
    $[19] = isSelected;
    $[20] = isTop;
    $[21] = isUpdated;
    $[22] = ranking;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== cardRef || $[25] !== isDwellPlaying || $[26] !== isHoverSupported || $[27] !== isHovered) {
    t9 = <ViverseWorldCardMedia isHovered={isHovered} isHoverSupported={isHoverSupported} isDwellPlaying={isDwellPlaying} cardRef={cardRef} />;
    $[24] = cardRef;
    $[25] = isDwellPlaying;
    $[26] = isHoverSupported;
    $[27] = isHovered;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== cardOnly) {
    t10 = !cardOnly && <ViverseWorldCardInfo />;
    $[29] = cardOnly;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== dwellRef || $[32] !== onContextMenu || $[33] !== onPointerEnter || $[34] !== onPointerLeave || $[35] !== onTouchCancel || $[36] !== onTouchEnd || $[37] !== onTouchStart || $[38] !== props || $[39] !== t10 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8 || $[43] !== t9) {
    t11 = <div {...props} data-component="world-card-v2" ref={dwellRef} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} onContextMenu={onContextMenu} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onTouchCancel={onTouchCancel} className={t6}>{t7}{t8}{t9}{t10}</div>;
    $[31] = dwellRef;
    $[32] = onContextMenu;
    $[33] = onPointerEnter;
    $[34] = onPointerLeave;
    $[35] = onTouchCancel;
    $[36] = onTouchEnd;
    $[37] = onTouchStart;
    $[38] = props;
    $[39] = t10;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  return t11;
}